<template>
  <div>
    <sw-table
      v-loading="loading"
      :show-selection="false"
      :pagination="false"
      :table-name="'sw-table-assignee'"
      :table-data="tableData"
      :table-title="tableTitle"
      :has-operation="false"
    />
  </div>
</template>

<script>
import service from '@/utils/service.js'
export default {
  props: {
    taskid: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      tableTitle: [
        { prop: 'accountName', label: '工号' },
        { prop: 'assigneeName', label: '姓名' },
        { prop: 'organizationName', label: '组织机构' }
      ],
      tableData: [],
      loading: false
    }
  },
  watch: {
    taskid (val) {
      this.getAssigneeByTaskId()
    }
  },
  created () {
    this.getAssigneeByTaskId()
  },
  methods: {
    getAssigneeByTaskId () {
      const params = {
        taskid: this.taskid
      }
      this.loading = true
      service.get('/v1/process/getAssigneeByTaskId', { params }).then(res => {
        this.tableData = res.data
        this.loading = false
      }).catch(err => {
        this.$swMessage({
          message: '获取当前节点办理人失败，请稍后再试' + err.message,
          type: 'error'
        })
      })
    }
  }
}
</script>

<style>
</style>
